import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Format Align Center"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-format-align-center',
    templateUrl: './icon-format-align-center.component.html',
    styleUrls: ['./icon-format-align-center.component.scss'],
    standalone: false
})
export class IconFormatAlignCenterComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
